module.exports = __webpack_public_path__ + "static/img/cabinet24_15.670783da.gif";